<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Create new team</h1>
        </template>
        
        <div>
            <div class="my-4 w-full">
                <label for="name" class="font-bold">Team Name</label>
                <input type="text" name="name" id="name" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" placeholder="Your team name" v-model="name">
                <p class="text-destructive" v-if="errors.name && errors.name.length > 0">{{ errors.name[0] }}</p>
            </div>

            <div class="my-4 w-full">
                <label for="email" class="font-bold">Team Email Address</label>
                <input type="text" name="email" id="email" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" placeholder="billing@example.com" v-model="email">
                <p class="text-sm text-gray-darker">This email address will be used for important notifications and billing purposes.</p>
                <p class="text-destructive" v-if="errors.email && errors.email.length > 0">{{ errors.email[0] }}</p>
            </div>

            <div class="my-4 w-full">
                <label for="profile" class="font-bold">Company Profile</label>
                <textarea name="profile" id="profile" rows="5" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" v-model="profile"></textarea>
                <p class="text-sm text-gray-darker">This information will be reflected on the invoices. Use it for tax information, billing address, etc.</p>
                <p class="text-destructive" v-if="errors.profile && errors.profile.length > 0">{{ errors.profile[0] }}</p>
            </div>

            <div class="my-4 w-full">
                <label class="font-bold">Choose the billing frequency</label>
                <minimal-paid-plan
                    :current="plan"
                    id="v2-team"
                    :monthly-price="49"
                    :yearly-price="468"
                    :monthly-additional-price="10"
                    :yearly-additional-price="96"
                    @picked="onChoosenPlanChanged"
                ></minimal-paid-plan>
            </div>
        </div>

        <span class="border-t border-gray-dark block"></span>

        <div v-if="loaded">
            <div class="my-4 w-full">
                <p>You'll be billed: <strong>{{ price }}</strong></p>
            </div>

            <div class="my-4 w-full">
                <card-input :stripe-key="stripeKey" :client-secret="clientSecret" ref="card"></card-input>
            </div>

            <div class="my-4 w-full">
                <label for="coupon" class="font-bold">Do you have any coupon code?</label>
                <input type="text" name="coupon" id="coupon" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full uppercase" placeholder="COUPON" v-model="coupon">
                <p class="text-destructive" v-if="errors.coupon && errors.coupon.length > 0">{{ errors.coupon[0] }}</p>
            </div>

            <div class="mt-4 w-full">
                <p class="text-destructive" v-if="errors.general && errors.general.length > 0">{{ errors.general[0] }}</p>
            </div>
        </div>
        <div v-else>
            <loading />
        </div>

        <template v-slot:footer v-if="loaded">
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Creating..."
                @click.native="create"
            >
                Create
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    data() {
        return {
            loaded       : false,
            name         : '',
            email        : '',
            profile      : '',
            loading      : false,
            stripeKey    : null,
            clientSecret : null,
            plan         : 'v2-team-yearly',
            price        : '',
            paymentMethod: null,
            coupon       : '',
            errors       : {},
        }
    },
    mounted() {
        this.makeIntent();
    },
    methods: {
        makeIntent() {
            this.loaded = false;

            axios.post('/api/subscription/intents', {
                plan: this.plan,
            })
            .then(response => {
                this.stripeKey = response.data.data.key;
                this.clientSecret = response.data.data.intent;
                this.price = response.data.data.price;

                this.loaded = true;
            })
            .catch(console.error);
        },
        onChoosenPlanChanged(plan) {
            this.plan = plan;

            this.makeIntent();
        },
        async create() {
            this.errors = {};
            this.loading = true;
            
            // if the card is not tokenized already, we'll tokenize it
            if (this.paymentMethod === null) {
                const paymentMethod = await this.$refs.card.tokenize();
                // if any error tokenizing, we'll bail out
                if (!paymentMethod) {
                    this.loading = false;
                    return;
                }
                this.paymentMethod = paymentMethod;
            }
            
            axios.post('/api/teams', {
                name          : this.name,
                email         : this.email,
                profile       : this.profile,
                payment_method: this.paymentMethod,
                plan          : this.plan,
                coupon        : this.coupon,
            })
            .then(response => {
                this.$emit('resolve', response.data.data);
            })
            .catch(err => {
                this.errors = err.response.data.errors;
                this.loading = false;
                console.error(err);
            }).then(() => {
                this.loading = false;
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>